<template>
  <div>
    <v-dialog v-model="dialog_open" scrollable max-width="800" persistent>
      <v-card height="auto" flat>
        <v-form ref="form">
          <v-card-title class="py-3">
            <v-row class="pa-6">
              <span class="font-weight-bold text-00a99d font-24">
                ค้นหาข้อมูล
              </span>
              <v-spacer></v-spacer>
              <v-btn icon color="#00a99d" @click="closeDialog()">
                <v-icon color="#00a99d">mdi-close</v-icon>
              </v-btn>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row class="pt-4 px-5">
              <!-- <v-col cols="12" lg="4" sm="4" class="mt-9 py-0" no-gutters>
              </v-col> -->
              <v-col cols="12" lg="6" sm="6" class="mt-3 py-0" no-gutters>
                <h3 class="ml-2 font-weight-bold">ชื่อผู้ป่วย</h3>
                <v-autocomplete v-model="patient" :items="patientList" return-object @keyup="getPatientList"
                  @change="search()" solo dense hide-details class="mt-3" placeholder="กรุณาเลือกผู้ป่วย"
                  no-data-text="ไม่พบข้อมูล"></v-autocomplete>
              </v-col>

              <v-col cols="12" lg="6" sm="6" class="mt-3 py-0" no-gutters>
                <h3 class="ml-2 font-weight-bold">ประเภทเอกสาร</h3>
                <v-select class="mt-3" placeholder="กรุณาเลือกประเภทเอกสาร" v-model="datadocCode" solo dense
                  :items="documentType" item-text="doc_name" color="#00A99D" item-color="teal darken-2" return-object
                  :menu-props="{ bottom: true, offsetY: true }" @change="search()">
                  <template v-slot:append>
                    <img src="@/assets/icon/medcert/down.svg" alt="down" />
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="px-5"> </v-row>
            <v-row class="mt-2 px-5">
              <v-col cols="12" align="center">
                <v-divider width="650" color="#ceefed"></v-divider>
              </v-col>
            </v-row>
            <v-row class="pa-5">
              <v-col cols="12" align="center">
                <!-- <span class="font-weight-bold" style="color: #003366; font-size:24px;">ไม่พบข้อมูล</span> -->
                <v-btn rounded dark :disabled="disabled_btn_request" color="#00a99d" @click="requestDoc()"
                  class="card-medium">ขอเอกสาร</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- <DialogForm
      ref="dialog_form"
      @cloesdiolog_req_doc="closeDialog"
    ></DialogForm> -->
    <!-- <DialogFormAlready
      ref="dialog_form_already"
      @cloesdiolog_req_doc="closeDialog"
    ></DialogFormAlready> -->
    <!-- <DialogFormCovid
      ref="dialog_form_covid"
      @cloesdiolog_req_doc="closeDialog"
    ></DialogFormCovid> -->
    <!-- <Vaccine ref="dialog_vaccine" @cloesdiolog_req_doc="closeDialog"></Vaccine> -->
    <!-- <VaccineTh ref="dialog_vaccine_th" @cloesdiolog_req_doc="closeDialog"></VaccineTh> -->
    <!-- <RecoverForm ref="dialog_recover" @cloesdiolog_req_doc="closeDialog"></RecoverForm> -->
    <!-- <AntibodyApprove ref="dialog_antibody" @cloesdiolog_req_doc="closeDialog"></AntibodyApprove> -->
    <!-- <CovidByATK ref="dialog_covid_by_atk" @cloesdiolog_req_doc="closeDialog"></CovidByATK> -->
    <MedCert ref="dialog_medcert" />
    <DrivingLicense ref="dialog_driving" />
    <formForeingWorkers ref="dialog_foreingworkers" />
    <ControlledHerbs ref="dialog_controlled_herbs" />
    <PrescriptionCert ref="dialog_prescription_cert" />
    <CommentCert ref="dialog_comment_cert" />
  </div>
</template>
<script>
import moment from "moment";
// import DialogForm from '@/components/dialog/RequestFormDialog.vue'
// import DialogFormAlready from '@/components/dialog/RequestAlreadyFormDialog.vue'
// import DialogFormCovid from '@/components/dialog/RequestFormCovidDialog.vue'
// import Vaccine from '@/components/dialog/VaccineApprove.vue'
// import VaccineTh from '@/components/dialog/VaccineThApprove.vue'
// import RecoverForm from '@/components/dialog/RecoverFormRequest01.vue'
// import AntibodyApprove from '@/components/dialog/AntibodyApproveRequest.vue'
// import CovidByATK from '@/components/dialog/RequestFormCovidByATK.vue'
import MedCert from "@/components/dialog/MedcertDialog.vue";
import DrivingLicense from "@/components/dialog/DrivingLicenseDialog.vue";
import formForeingWorkers from "@/components/dialog/MedcertForeingWorkersDialog.vue";
import ControlledHerbs from "@/components/dialog/ControlledHerbsDialog.vue";
import PrescriptionCert from "@/components/dialog/PrescriptionCertDialog.vue";
import CommentCert from "@/components/dialog/CommentCertDialog.vue";
// import functioncryto from "@/services/encrypt.js";

export default {
  components: {
    // DialogForm,
    // DialogFormAlready,
    // DialogFormCovid,
    // Vaccine,
    // VaccineTh,
    // RecoverForm,
    // AntibodyApprove,
    // CovidByATK,
    MedCert,
    DrivingLicense,
    formForeingWorkers,
    ControlledHerbs,
    PrescriptionCert,
    CommentCert
  },
  data: () => ({
    headers: [
      {
        text: "วันที่เข้ารับการรักษา",
        align: "start",
        sortable: false,
        value: "date",
        width: "30%",
      },
      {
        text: "ประเภทเอกสาร",
        align: "start",
        sortable: false,
        value: "doc_type",
        width: "50%",
      },
      {
        text: "",
        align: "right",
        sortable: false,
        value: "action",
        width: "20%",
      },
    ],
    dialog_open: false,
    data: "",
    items_cards: [
      "เลขประจำตัวประชาชน",
      "เลข PASSPORT",
      "เลขประจำตัวประชาชนคนซึ่งไม่มีสัญชาติไทย",
    ],
    cardSelect: "เลขประจำตัวประชาชน",
    req_body: {},
    // select_doc: 'รายชื่อผู้ป่วย',
    // doc_list: ['รายชื่อผู้ป่วย'],
    keyword_id: "",
    not_match_input: false,
    rules: {
      required: (v) => !!v || "กรุณากรอกข้อมูล",
      min: (v) =>
        v && v.length === 13 || "กรุณากรอกเลขบัตรประชาชน 13 หลักให้ถูกต้อง",
      emailMatch: () => "The email and password you entered don't match",
    },
    documentType: [],
    hospital_code: "",
    datadocCode: "",
    patientFullNameThai: "",
    patientIdCard: "",
    biz_id: "",
    disabled_btn_request: true,
    search_patient: "",
    card_type_item: [
      { cardtype: "บัตรประชาชน", value: "เลขประจำตัวประชาชน" },
      { cardtype: "PASSPORT", value: "PASSPORT" },
    ],

    patientList: [],
    patient: null,
  }),
  computed: {},
  created() { },

  watch: {
    // dialog (val) {
    //   val || this.closeDialog()
    // }
    cardSelect() {
      this.keyword_id = ""
      this.$refs.form.resetValidation()
    },
    dialog_open(val) {
      if (!val) {
        this.keyword_id = ""
        this.$refs.form.resetValidation()
      }
    }
  },
  methods: {
    async getDocType() {
      // console.log("cryto", functioncryto.encrypt("1234567890987"))
      let params = new URLSearchParams();
      params.append("biz_id", this.biz_id);
      this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/getDocType?${params}`)
        .then((res) => {
          // console.log("res", res)
          let data = res.data.data[0]

          if (data.default.length > 0) {
            for (let item of data.default) {
              this.documentType.push(item)
            }
          }

          if (data.biz.length > 0) {
            for (let item of data.biz) {
              this.documentType.push(item)
            }
          }
        });
    },
    async requestDoc() {
      // console.log("item", item)
      try {
        let params = new URLSearchParams();

        params.append("biz_id", sessionStorage.biz_id);
        params.append("doc_type", this.datadocCode.doc_code);
        params.append("patient", this.patient.value.cid); //functioncryto.encrypt(this.keyword_id)
        params.append("doctor", sessionStorage.oneId);
        // console.log("functioncryto.encrypt(this.keyword_id)", functioncryto.decrypt("M6pKgpq6wmkton96teiStg=="))
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/dataCert?${params}`)
          // .get(`http://localhost:5000/v1/dataCert?${params}`)
          .then((res) => {
            // console.log(">>> data cert", res)
            let data = res.data.data;

            let item = {
              mode: "input",
              doc_code: this.datadocCode.doc_code,
              doc_name: this.datadocCode.doc_name,
              item: data,
              patient_id: res.data.patient_id
            };

            if (this.datadocCode.doc_code === "MEDICAL_CERTIFICATE") {
              this.$refs.dialog_medcert.open(item);
              // this.$refs.dialog_driving.open(item)
              this.dialog_open = false;
              // console.log("ใบรับรองแพทย์")
            } else if (this.datadocCode.doc_code === "DRIVING_LICENSE") {
              this.$refs.dialog_driving.open(item)
              this.dialog_open = false;
            } else if (this.datadocCode.doc_code === "FORMFOREINGWORKERS") {
              this.$refs.dialog_foreingworkers.open(item)
              this.dialog_open = false;
            } else if (this.datadocCode.doc_code === "CONTROLLED_HERBS") {
              this.$refs.dialog_controlled_herbs.open(item)
              this.dialog_open = false;
            } else if (this.datadocCode.doc_code === "PRESCRIPTION_CERT") {
              this.$refs.dialog_prescription_cert.open(item)
              this.dialog_open = false;
            } else if (this.datadocCode.doc_code === "COMMENT_CERT") {
              this.$refs.dialog_comment_cert.open(item)
              this.dialog_open = false;
            }
            return;
          });
      } catch (err) {
        console.log(err);
        if (err.response.data.message === "This doc_type not found") {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่พบเอกสาร</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
          return
        } else if (err.response.data.message === "This patient one_id not found") {
          this.$swal.fire({
            icon: "error",
            title: `<span style="font-size: 20px;">ไม่พบผู้ป่วยนี้ในระบบ</span>`,
            showConfirmButton: false,
            timer: 2000,
          });
          return
        }
        this.$swal.fire({
          icon: "error",
          title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      // if (!this.testAlready) {
      //   if (this.datadocCode.doc_code === "MEDICAL_CERTIFICATE") {
      //     this.$refs.dialog_medcert.open(item)
      //     this.dialog_open = false
      //     console.log("ใบรับรองแพทย์")
      //   }
      // } else {
      //   this.$refs.dialog_form_already.open(item)
      // }
    },
    setDateFormat(date) {
      return moment(date)
        .locale("th")
        .add(543, "year")
        .format("DD/MM/YYYY")
        .replace(/(^|-)0+/g, "$1");
    },
    setTimeFormat(time) {
      return moment(time).locale("th").add(543, "year").format("HH:mm น.");
    },
    search() {
      if (this.datadocCode && Object.keys(this.patient).length > 0) {
        this.disabled_btn_request = false;
      } else {
        this.disabled_btn_request = true;
      }
    },
    open() {
      this.dialog_open = true;
      // this.keyword_id = '3100905407362'
      this.keyword_id = "";
      this.keyword_call_no = "";
      this.datadocCode = "";
      // this.list_row = []
      this.disabled_btn_request = true;

      // console.log(">>> biz id <<<", sessionStorage.biz_id)
      this.biz_id = sessionStorage.biz_id;
      this.patient = {};
      this.getPatientList()

      this.getDocType();

      // this.removeRules()
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    // removeRules () {
    //   this.not_match_input = false
    // },
    closeDialog() {
      this.dialog_open = false;
      // refreshdata กรณีไม่เคยมีประวัติการขอเอกสาร
      this.$emit("refreshdata");
    },
    getPatientList(search) {
      let word = "";
      if (search !== undefined) {
        if (search.target.value.length !== 0) {
          word = search.target.value;
        }
      }
      this.patientList = [];
      let params = new URLSearchParams();
      params.append("biz_id", sessionStorage.biz_id);
      params.append("search", word);
      params.append("limit", 1000);
      this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients/search?${params}`)
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.data[0]) {
              res.data.data[0].data.forEach((ele) => {
                this.patientList.push({
                  text: ele.first_name_th + " " + ele.last_name_th,
                  mobile: ele.mobile,
                  value: ele,
                });
              });
            }
          }
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(255, 255, 255) !important;
}

.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-input>.v-input__control>.v-input__slot>.v-select__slot>.v-select__selections>.v-select__selection {
  line-height: 1.7rem;
}
</style>
